import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Voltar")
], -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 0,
  class: "ui-reserva-disponibilidade-box"
}
const _hoisted_4 = { class: "ant-row ui-reserva-disponibilidade-box-detalhe" }
const _hoisted_5 = { class: "ant-col ant-col-xs-12 ant-col-xl-12 ui-align-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Check-In:", -1)
const _hoisted_7 = { class: "ant-col ant-col-xs-12 ant-col-xl-12 ui-align-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Check-Out:", -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-12 ui-align-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Check-In:", -1)
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-12 ui-align-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", null, "Check-Out:", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24 ui-align-center" }, " Disponível ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.state.computedVisivel)
    ? (_openBlock(), _createBlock(_component_a_modal, {
        key: 0,
        keyboard: false,
        centered: "",
        width: "100%",
        "wrap-class-name": "ui-full-modal",
        title: _ctx.obtemTituloModal(),
        visible: _ctx.state.computedVisivel,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.computedVisivel) = $event))
      }, {
        footer: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              class: "ui-button -second",
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.computedVisivel = false))
            }, _hoisted_2)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            id: "uni-reserva",
            ref: "el",
            layout: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: _ctx.appBase.carregando
              }, {
                default: _withCtx(() => [
                  ((_ctx.state.apresentarBoxes))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.disponibilidadesBoxes, (box) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "card",
                            key: box.codigoBox
                          }, [
                            _createElementVNode("h1", null, "Box: " + _toDisplayString(box.identificacao), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box.reservas, (reserva, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: 'RSV' + box.codigoBox + index
                              }, [
                                (_ctx.UtilitarioGeral.valorValido(reserva.nomeCliente))
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      title: "Visualizar Reserva",
                                      class: "ui-link",
                                      to: { name: 'ReservaCadastroEditar', params: { codigo:reserva.codigoReserva }}
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_4, [
                                          _createElementVNode("div", _hoisted_5, [
                                            _hoisted_6,
                                            _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(reserva.dataCheckIn)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_7, [
                                            _hoisted_8,
                                            _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(reserva.dataChekOut)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_9, " Reservado para: " + _toDisplayString(reserva.nomeCliente), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      title: "Criar Nova Reserva",
                                      onClick: ($event: any) => (_ctx.criarReserva(reserva)),
                                      class: "ant-row ui-reserva-disponibilidade-box-detalhe-disponivel"
                                    }, [
                                      _createElementVNode("div", _hoisted_11, [
                                        _hoisted_12,
                                        _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(reserva.dataCheckIn)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_13, [
                                        _hoisted_14,
                                        _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataAnoAbreviado(reserva.dataChekOut)), 1)
                                      ]),
                                      _hoisted_15
                                    ], 8, _hoisted_10))
                              ], 64))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }, 512)
        ]),
        _: 1
      }, 8, ["title", "visible"]))
    : _createCommentVNode("", true)
}